import React from 'react';
import Typography from '@mui/material/Typography';
import { currencyInputUtils } from '../../../../../../utils/currencyInput.utils';
import useEmotionStyles from '../../../../../../uikit/hooks/useEmotionStyles';
var styles = function (theme) {
    var _a, _b, _c, _d, _e;
    return ({
        table: (_a = {
                width: '100%',
                borderCollapse: 'collapse'
            },
            _a['& td'] = {
                border: 'none',
                paddingBottom: theme.spacing(1),
            },
            _a),
        baseRow: (_b = {},
            _b['& td'] = (_c = {
                    verticalAlign: 'bottom',
                    paddingBottom: theme.spacing(2)
                },
                _c['& span'] = (_d = {
                        lineHeight: 1
                    },
                    _d[theme.breakpoints.down('sm')] = {
                        fontSize: '.9em',
                    },
                    _d),
                _c),
            _b),
        moduleCell: {
            width: '10px',
            paddingRight: theme.spacing(1),
            fontWeight: 700,
        },
        titleCell: {
            paddingRight: theme.spacing(1),
        },
        valueCell: {
            whiteSpace: 'nowrap',
        },
        totalRow: (_e = {},
            _e['& > td'] = {
                paddingTop: theme.spacing(2),
                borderTop: "2px solid ".concat(theme.palette.grey[200]),
            },
            _e),
        totalTitleCell: {
            paddingRight: theme.spacing(1),
            textAlign: 'right',
        },
        totalValueCell: {
            whiteSpace: 'nowrap',
        },
        totalCellLabel: {
            fontSize: '1.2em',
            fontWeight: 700,
        },
    });
};
function makePreparedValue(value) {
    return "".concat(currencyInputUtils.numberToString(Math.ceil(value)), "\u20AC");
}
export var CheckoutTable = function (_a) {
    var rows = _a.rows, total = _a.total;
    var cs = useEmotionStyles(styles);
    return (React.createElement("table", { className: cs.table },
        React.createElement("tbody", null,
            rows.map(function (_a) {
                var module = _a.module, title = _a.title, value = _a.value;
                return (React.createElement("tr", { key: title, className: cs.baseRow },
                    React.createElement("td", { className: cs.moduleCell }, module && React.createElement(Typography, { component: 'span' }, module)),
                    React.createElement("td", { className: cs.titleCell },
                        React.createElement(Typography, { component: 'span' },
                            title,
                            ":")),
                    React.createElement("td", { className: cs.valueCell },
                        React.createElement(Typography, { component: 'span' }, makePreparedValue(value)))));
            }),
            total && (React.createElement("tr", { className: cs.totalRow },
                React.createElement("td", { className: cs.totalTitleCell, colSpan: 2 },
                    React.createElement(Typography, { className: cs.totalCellLabel, component: 'span' },
                        total.title,
                        ":")),
                React.createElement("td", { className: cs.totalValueCell },
                    React.createElement(Typography, { className: cs.totalCellLabel, component: 'span' }, makePreparedValue(total.value))))))));
};
